@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package photo_fx.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val effect_controls_chromatic_aberration_intensity: StringResource by 
      lazy { init_effect_controls_chromatic_aberration_intensity() }

  public val effect_controls_smooth_pixelation_pixel_size: StringResource by 
      lazy { init_effect_controls_smooth_pixelation_pixel_size() }

  public val effect_controls_vignette_decay_factor: StringResource by 
      lazy { init_effect_controls_vignette_decay_factor() }

  public val effect_controls_vignette_intensity: StringResource by 
      lazy { init_effect_controls_vignette_intensity() }

  public val effect_gallery_chromatic_aberration: StringResource by 
      lazy { init_effect_gallery_chromatic_aberration() }

  public val effect_gallery_smooth_pixelation: StringResource by 
      lazy { init_effect_gallery_smooth_pixelation() }

  public val effect_gallery_vignette: StringResource by 
      lazy { init_effect_gallery_vignette() }

  public val effect_selection_image_with_effect: StringResource by 
      lazy { init_effect_selection_image_with_effect() }

  public val effect_selection_title: StringResource by 
      lazy { init_effect_selection_title() }

  public val generic_accept: StringResource by 
      lazy { init_generic_accept() }

  public val generic_close: StringResource by 
      lazy { init_generic_close() }

  public val generic_next: StringResource by 
      lazy { init_generic_next() }

  public val generic_reset: StringResource by 
      lazy { init_generic_reset() }

  public val photo_gallery_description: StringResource by 
      lazy { init_photo_gallery_description() }

  public val photo_selection_title: StringResource by 
      lazy { init_photo_selection_title() }

  public val playground_title: StringResource by 
      lazy { init_playground_title() }

  public val selection_indicator: StringResource by 
      lazy { init_selection_indicator() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("effect_controls_chromatic_aberration_intensity", CommonMainString0.effect_controls_chromatic_aberration_intensity)
  map.put("effect_controls_smooth_pixelation_pixel_size", CommonMainString0.effect_controls_smooth_pixelation_pixel_size)
  map.put("effect_controls_vignette_decay_factor", CommonMainString0.effect_controls_vignette_decay_factor)
  map.put("effect_controls_vignette_intensity", CommonMainString0.effect_controls_vignette_intensity)
  map.put("effect_gallery_chromatic_aberration", CommonMainString0.effect_gallery_chromatic_aberration)
  map.put("effect_gallery_smooth_pixelation", CommonMainString0.effect_gallery_smooth_pixelation)
  map.put("effect_gallery_vignette", CommonMainString0.effect_gallery_vignette)
  map.put("effect_selection_image_with_effect", CommonMainString0.effect_selection_image_with_effect)
  map.put("effect_selection_title", CommonMainString0.effect_selection_title)
  map.put("generic_accept", CommonMainString0.generic_accept)
  map.put("generic_close", CommonMainString0.generic_close)
  map.put("generic_next", CommonMainString0.generic_next)
  map.put("generic_reset", CommonMainString0.generic_reset)
  map.put("photo_gallery_description", CommonMainString0.photo_gallery_description)
  map.put("photo_selection_title", CommonMainString0.photo_selection_title)
  map.put("playground_title", CommonMainString0.playground_title)
  map.put("selection_indicator", CommonMainString0.selection_indicator)
}

internal val Res.string.effect_controls_chromatic_aberration_intensity: StringResource
  get() = CommonMainString0.effect_controls_chromatic_aberration_intensity

private fun init_effect_controls_chromatic_aberration_intensity(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:effect_controls_chromatic_aberration_intensity", "effect_controls_chromatic_aberration_intensity",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 10, 66),
    )
)

internal val Res.string.effect_controls_smooth_pixelation_pixel_size: StringResource
  get() = CommonMainString0.effect_controls_smooth_pixelation_pixel_size

private fun init_effect_controls_smooth_pixelation_pixel_size(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:effect_controls_smooth_pixelation_pixel_size", "effect_controls_smooth_pixelation_pixel_size",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 77, 68),
    )
)

internal val Res.string.effect_controls_vignette_decay_factor: StringResource
  get() = CommonMainString0.effect_controls_vignette_decay_factor

private fun init_effect_controls_vignette_decay_factor(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:effect_controls_vignette_decay_factor", "effect_controls_vignette_decay_factor",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 146, 61),
    )
)

internal val Res.string.effect_controls_vignette_intensity: StringResource
  get() = CommonMainString0.effect_controls_vignette_intensity

private fun init_effect_controls_vignette_intensity(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:effect_controls_vignette_intensity", "effect_controls_vignette_intensity",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 208, 54),
    )
)

internal val Res.string.effect_gallery_chromatic_aberration: StringResource
  get() = CommonMainString0.effect_gallery_chromatic_aberration

private fun init_effect_gallery_chromatic_aberration(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:effect_gallery_chromatic_aberration", "effect_gallery_chromatic_aberration",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 263, 71),
    )
)

internal val Res.string.effect_gallery_smooth_pixelation: StringResource
  get() = CommonMainString0.effect_gallery_smooth_pixelation

private fun init_effect_gallery_smooth_pixelation(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:effect_gallery_smooth_pixelation", "effect_gallery_smooth_pixelation",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 335, 64),
    )
)

internal val Res.string.effect_gallery_vignette: StringResource
  get() = CommonMainString0.effect_gallery_vignette

private fun init_effect_gallery_vignette(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:effect_gallery_vignette", "effect_gallery_vignette",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 400, 43),
    )
)

internal val Res.string.effect_selection_image_with_effect: StringResource
  get() = CommonMainString0.effect_selection_image_with_effect

private fun init_effect_selection_image_with_effect(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:effect_selection_image_with_effect", "effect_selection_image_with_effect",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 444, 78),
    )
)

internal val Res.string.effect_selection_title: StringResource
  get() = CommonMainString0.effect_selection_title

private fun init_effect_selection_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:effect_selection_title", "effect_selection_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 523, 54),
    )
)

internal val Res.string.generic_accept: StringResource
  get() = CommonMainString0.generic_accept

private fun init_generic_accept(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:generic_accept", "generic_accept",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 578, 30),
    )
)

internal val Res.string.generic_close: StringResource
  get() = CommonMainString0.generic_close

private fun init_generic_close(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:generic_close", "generic_close",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 609, 29),
    )
)

internal val Res.string.generic_next: StringResource
  get() = CommonMainString0.generic_next

private fun init_generic_next(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:generic_next", "generic_next",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 639, 28),
    )
)

internal val Res.string.generic_reset: StringResource
  get() = CommonMainString0.generic_reset

private fun init_generic_reset(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:generic_reset", "generic_reset",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 668, 29),
    )
)

internal val Res.string.photo_gallery_description: StringResource
  get() = CommonMainString0.photo_gallery_description

private fun init_photo_gallery_description(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:photo_gallery_description", "photo_gallery_description",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 698, 53),
    )
)

internal val Res.string.photo_selection_title: StringResource
  get() = CommonMainString0.photo_selection_title

private fun init_photo_selection_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:photo_selection_title", "photo_selection_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 752, 49),
    )
)

internal val Res.string.playground_title: StringResource
  get() = CommonMainString0.playground_title

private fun init_playground_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:playground_title", "playground_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 802, 48),
    )
)

internal val Res.string.selection_indicator: StringResource
  get() = CommonMainString0.selection_indicator

private fun init_selection_indicator(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:selection_indicator", "selection_indicator",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/photo_fx.composeapp.generated.resources/values/strings.commonMain.cvr", 851, 39),
    )
)
